import React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../../components/layout/Layout'; // Layout padrão que utilizamos
import Button from '../../components/common/Button'; // Botão genérico

const ConvenioDetails = () => {
  const { convenioName } = useParams(); // Pega o nome do convênio da URL

  // Exemplo de detalhes adicionais
  const convenioDetailsData = {
    unimed: {
      name: 'Unimed',
      cobertura: 'Ampla cobertura nacional e internacional.',
      autorizacoes: 'Autorização para consultas, exames e internações.',
      procedimentos: 'Procedimentos cirúrgicos e tratamentos específicos.',
    },
    amil: {
      name: 'Amil',
      cobertura: 'Cobertura nacional em hospitais e clínicas.',
      autorizacoes: 'Autorização para tratamentos e exames especializados.',
      procedimentos: 'Procedimentos ambulatoriais e cirúrgicos.',
    },
    // ... outros convênios
  };

  const convenioDetails = convenioDetailsData[convenioName.toLowerCase()] || {
    name: 'Convênio não encontrado',
    cobertura: '',
    autorizacoes: '',
    procedimentos: '',
  };

  return (
    <Layout>
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">
          Detalhes do Convênio: {convenioDetails.name}
        </h1>

        <section>
          <h2 className="text-lg font-semibold mt-6">Cobertura</h2>
          <p>{convenioDetails.cobertura}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mt-6">Autorizações</h2>
          <p>{convenioDetails.autorizacoes}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold mt-6">Procedimentos</h2>
          <p>{convenioDetails.procedimentos}</p>
        </section>

        <div className="flex space-x-4 mt-6">
          <Button
            label="Voltar"
            onClick={() => window.history.back()}
            className="hover:bg-secondary"
          />
        </div>
      </div>
    </Layout>
  );
};

export default ConvenioDetails;
